import { createSelector, Selector } from 'reselect'

import { PricesInitialState } from '../model/prices.model'

import { RootState } from '~/core/store/root.reducer'

type GetPrices = Selector<RootState, PricesInitialState>

const getPrices: GetPrices = (state) => state.prices

export const selectTaxValue = createSelector(getPrices, (prices) => prices.data.tax.value)

export const selectTaxName = createSelector(getPrices, (prices) =>
  prices.data.tax.name === 'Sin impuestos' ? prices.data.tax.name : `${prices.data.tax.name}. INC.`,
)

export const selectTaxId = createSelector(getPrices, (prices) => prices.data.tax.id)
